// c: array of multi-kill medal names, indexed by kill streak threshold (0 = Double Kill, 6 = Super Kill)
var feeds = [
  "Double Kill",
  "Triple Kill",
  "Quad Kill",
  "Multi Kill",
  "Mega Kill",
  "Ultra Kill",
  "Super Kill",
];

// d: shared results buffer reused each call to avoid allocations; holds alternating [medalName, score] pairs
var tmpList = [];

// export: reward
// Evaluates a kill event and returns a flat array of [medalName, scoreValue, ...] pairs, or null if no medals earned.
// f: unused parameter (reserved / legacy)
// g: the killer player object (stats, state, weapon, etc.)
// h: the victim player object
// j: the kill event data object (weapon override, flags like hs/wb/pj/fs, distance, etc.)
// k: the game/match state object (mode config, total kill count, etc.)
// m: optional physics/movement object used to compute velocity for Turbo Kill detection
module.exports.reward = function (f, killer, victim, killInfo, game, UTILS) {
  // Reset the results buffer for this call
  tmpList.length = 0;

  // p: the weapon used in this kill — falls back to killer's current weapon if kill event has no weapon override
  var p = killInfo.w == null ? killer.weapon : killInfo.w;

  if (game.mode.weaponOrder) {
    // Weapon-order mode: only award melee-based shaming or a promotion point
    if (p.melee) {
      tmpList.push("Humiliation", null); // Killed with melee in weapon-order mode
    } else {
      tmpList.push("Promotion", 1); // Killed with the required weapon; advance weapon order
    }
  } else {
    // Standard mode: evaluate all applicable medals

    if (game.kills <= 1) {
      // First kill of the match
      tmpList.push("First Blood", 25);
      killer.firstblood++;
    }

    if (killer.lastKiller && victim && victim.id == killer.lastKiller) {
      // Killer just killed the player who previously killed them
      killer.lastKiller = null;
      tmpList.push("Revenge", 25);
      killer.revengeKills++;
    }

    if (p.melee) {
      // Melee kill sub-medals
      if (killInfo.pj) {
        // pj: projectile-assisted melee (e.g. throwing knife headshot)
        tmpList.push("Bullseye", 150);
      } else if (killInfo.fs) {
        // fs: finishing strike / close-range melee
        tmpList.push("Beatdown", 175);
      } else {
        tmpList.push("Execution", 150);
      }
    } else {
      // Ranged weapon kill sub-medals
      if (p.kill) {
        // Weapon has a custom kill medal defined
        tmpList.push(p.kill[0], p.kill[1]);
      } else if (p.scope && killer.aimVal == 1) {
        // aimVal == 1: fully zoomed scope, but fired without aiming — No Scope
        tmpList.push("No Scope", 100);
        killer.noscopes++;
      } else if (
        !p.scope ||
        (killer.aimVal == 0 && killer.aimTime > 180) ||
        killer.aimDir == 1
      ) {
        // No scope weapon, or hip-fire after long aim, or reverse-aim direction — standard kill
        tmpList.push("", 50);
      } else {
        // Scoped weapon fired quickly after aiming
        tmpList.push("Quick Scope", 75);
        killer.quickscopes++;
      }

      if (killInfo.hs) {
        // hs: headshot flag on the kill event
        tmpList.push("Headshot", 50);
      }

      if (killInfo.wb) {
        // wb: wallbang flag — bullet passed through a surface to hit the victim
        tmpList.push("Wallbang", 25);
      }

      if (!p.scope && killInfo.dst * p.range > 200) {
        // dst * range exceeds 200 units — long-distance kill with a non-scoped weapon
        tmpList.push("Longshot", 25);
        killer.longshots++;
      }
    }

    if (victim.flag) {
      // Victim was carrying a flag when killed
      tmpList.push("Snatched", 50);
    }

    if (killer.health <= killer.maxHealth * 0.2 && killer.active) {
      // Killer is at or below 20% health and still alive
      tmpList.push("Close Call", 20);
      killer.closecalls++;
    }

    if (killer.deathStreak >= 3) {
      // Killer had died 3+ times in a row before this kill
      tmpList.push("Comeback", 25);
    }

    if (victim.killStreak >= 10) {
      // Victim was on a 10+ kill streak
      tmpList.push("Buzzkill", 25);
    } else if (victim.killStreak >= 5) {
      // Victim was on a 5–9 kill streak
      tmpList.push("Buzzkill", 10);
    }

    if (killer.slideTimer > 0) {
      // Killer was sliding when they made the kill
      tmpList.push("Driftkill", 50);
      killer.driftkills++;
    }

    if (killer.airTime >= 400) {
      // Killer was airborne for at least 400ms
      tmpList.push("Mid Air", 25);
      killer.airKills++;
    }

    if (
      UTILS &&
      UTILS.getD3D(0, 0, 0, killer.velX, killer.velY, killer.velZ) * 1000 >= 180
    ) {
      // Killer's speed (converted from getD3D result) is >= 180 units/s — Turbo Kill
      killer.turboKills++;
      tmpList.push("Turbo Kill", 25);
    }

    // Check kill streak medals from highest to lowest; q is the streak index into c[]
    for (var i = feeds.length - 1; i >= 0; --i) {
      if (killer.streak > i) {
        tmpList.push(feeds[i], (i + 1) * 50);
        break;
      }
    }
  }

  if (tmpList.length) {
    return tmpList;
  } else {
    return null;
  }
};

// export: getScore
// Sums all numeric score values from a reward array returned by `reward`.
// killData: the reward array ([medalName, scoreValue, ...] pairs); may be null
module.exports.getScore = function (killData) {
  // g: running total of score points; starts null so caller can distinguish "no rewards" from 0
  var tmpScore = null;
  if (killData) {
    // h: loop index; iterates over every odd index (score values) in the rewards array
    for (var h = 1; h < killData.length; h += 2) {
      if (killData[h]) {
        tmpScore += killData[h];
      }
    }
  }
  return tmpScore;
};
